import React from "react";
import styled, { keyframes } from "styled-components";
import colors from "../../../utils/colors";
import { Localize } from "../../../locale/localization";
import ScoreVisualizer from "../../../ui/score/ScoreVisualizer";

const bgImg = `${process.env.PUBLIC_URL}/img/score-card-bg.png`;

const fadeInAnim = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const CardWrap = styled.div`
  background-color: ${colors.BRAND_RED_LIGHT};
  border-radius: 0.3125rem;
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.5217391304348%;
  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.2);

  animation-name: ${fadeInAnim};
  animation-duration: 0.66s;
  animation-timing-function: ease-out;
`;

const CardBackground = styled.figure`
  background: linear-gradient(${colors.BRAND_RED_LIGHT} 19%, ${colors.BRAND_RED} 100%);
  background-image: url(${bgImg});
  background-position: 50% 50%;
  background-size: cover;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(rgba(0,0,0,0.0) 32%, rgba(0,0,0,0.4) 82%)
  }
 }

  &:hover {
    &:after {
      background-image: linear-gradient(rgba(0, 0, 0, 0) 32%, rgba(0, 0, 0, 0.15) 82%);
    }
  }
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const CardContent = styled.div`
  color: white;
  position: absolute;
  bottom: 0;
  top: 0;
  z-index: 1;
  padding: 1.875rem 1.625rem 1.5rem 1.625rem;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  align-items: center;
`;

const CardTitle = styled.h5`
  font-family: FyranSans-Core;
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 1.18em;
  margin-bottom: 0.5rem;
  flex: 1;
  flex-grow: 1;
  align-content: baseline;
  margin-top: auto;
`;

const Score = styled.div`
  flex: 1;
`;

const ScoreCard = props => {
  const { score } = props;

  return (
    <div>
      <CardWrap>
        <CardBackground />
        <CardContent>
          <CardTitle>{Localize("score.now")}</CardTitle>
          <Score>
            <ScoreVisualizer tight percent={50} score={score} />
          </Score>
        </CardContent>
      </CardWrap>
    </div>
  );
};

export default ScoreCard;



// WEBPACK FOOTER //
// ./src/modules/common/components/ScoreCard.js